var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"columns is-multiline"},[_c('FilterWrapper',[_c('CustomDatepicker',{model:{value:(_vm.datepicker),callback:function ($$v) {_vm.datepicker=$$v},expression:"datepicker"}})],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }